import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate, MESSAGES,useParams } from './../../common/helper/common-imports.component.js';
import { initialFormData, initialErrors, fieldValidation, createMerchantData  } from '../../common/helper/form-constants.js';
import { FormField, SelectField } from './../../common/helper/formFields';
import TicketService from '../../../services/tickets-service.js';
import ticketsService from '../../../services/tickets-service.js';

const ReplyTicket = () => {
  const [content, setContent] = useState('');
  const maxLength = 500;
  const [fileUrl, setFileUrl] = useState('');
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState('address_details');
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({ ...initialErrors });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [ticketDetails,setTicketDetails] = useState([]);
  const [userRole,setUserRole] = useState();
  const userData = useSelector(state => state.authReducer);

   const naviagate = useNavigate()
    const back = () => {
        naviagate(-1); 
    }
   
  const getTicketDetails = () => {
  let ticketDetails =  TicketService.viewTicket(id )
  setLoading(true);
  ticketDetails.then(response => {
    const records = response.data.data
    setTicketDetails(records)
    setLoading(false);
  })
  .catch(error => {
    setLoading(false);
    try {
      const errorMessage = error.response.data
      toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
    } catch (e){
      toast.error( MESSAGES.SERVER_ERROR)
    }
  });
}
const ReplyToTicket= (isClose = false) => {
  const viewTicketData = ticketsService.getViewTicketFormData();
    let requierdFields= ['content'];
    
    if (!validateFields(requierdFields, formData)) return;
    setLoading(true);
    const data = new FormData();
    let request  = {
 
        content: formData.content,
        is_close: isClose,
        utr_id: formData.utr_id,
        is_agent_assign:viewTicketData.agentTicket,
        is_merchant_assign: viewTicketData.merchantTicket

    }
    data.append('file',fileUrl);

   data.append('data', JSON.stringify(request)); 
    TicketService.replyTicket(id,data)
      .then(response => {
        if(isClose) {
          toast.success(MESSAGES.TCK_CLSD)
          naviagate(`/tickets`)
        } else {
          naviagate(`/ticket-details/${id}`)
          toast.success(MESSAGES.TCK_RPLY)
        }
       
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        try {
          const errorMessage = error.response.data
          toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
        } catch (e){
          toast.error( MESSAGES.SERVER_ERROR)
        }
      });


}

const closeTicket= () => {
  let isClose = true
  ReplyToTicket(isClose)
}
 
  useEffect(() => {

    getTicketDetails();
    let userRole;
    if(userData && userData.user && userData.user.data) {
       userRole = userData.user.data.role.role_code
       setUserRole(userRole)
    }
    document.body.style.backgroundColor = '#f0f6fa';
        return () => {
          document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
        };
    }, []); 

 
  const validateFields = (fields, formData) => {
    let isValid = true;
    fields.forEach(fieldName => {
      const fieldValue = formData[fieldName];
      if (!fieldValue || !fieldValue.trim()) {
        validateField(fieldName, fieldValue || ''); 
        isValid = false;
      }
    });
    return isValid;
  };

 
  
   

 
  const handleFileChange  = (e) => {
    const file = e.target.files[0];
    const maxSize = 2 * 1024 * 1024; // 2 MB

    

    if (file && file.size <= maxSize) {
      setFileUrl(file);
    } else {
      setFileUrl('');
      toast.error('File size exceeds 2 MB. Please select a smaller file.');
    }

  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    validateField(name, value);
    if(name == 'content') {
      setContent(e.target.value);

    }
  };
 
  const validateField = (fieldName, value) => {
    const errorMessage = fieldValidation(fieldName, value);
    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));
  };

 
  return (
    <div>
    <LoaderOverlay loading={loading} />
    <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
    <h4 style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>Reply Ticket</h4>
    <div className="container-fluid ghty" style={{backgroundColor: 'white'}}>
      <form method="post" id="register_form" action="#" className="merchant_form">
        <ul className="nav nav-tabs">
   
          <li className="nav-item tbbtrn">
            <a className={`nav-link ${activeTab === 'address_details' ? 'active_tab1' : 'inactive_tab1'}`}  id="list_address_details">Enter Details</a>
          </li>
   
        </ul>
        <div className="tab-content" style={{marginTop: '16px'}}>
         
          <div className={`tab-pane ${activeTab === 'address_details' ? 'active' : 'fade'}`} id="address_details">
            <div className="panel panel-default">
              <div className="panel-body" style={{padding: '0px'}}>
                <div className="container col-md-12" style={{padding: 0}}>
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>

                  <div className="form-group frm" style={{textAlign: 'left'}}>
                    <FormField
                           type="text"
                           isRequierd = {false}
                           id="amount"
                           name="amount"
                           label="Ticket Number"
                           value={ticketDetails.ticket_code}
                          disabled={true}
                        />
                     
                    </div>
               
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <FormField
                           type="text"
                           isRequierd = {false}
                           id="utr_id"
                           name="utr_id"
                           label="UTR"
                           placeholder = "Enter Utr Id"
                          
                           onChange={handleChange}
                         
                           maxlength = {50}
                        />
                     
                    </div>

                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name" className='required'>Description</label>
                      <textarea type="text" style={{height:'100px',width:'612px'}} className={`form-control ${errors.content ? 'is-invalid' : ''}`}    placeholder="Reason" maxLength={maxLength} id="first_name" name="content" onChange={handleChange}/>
                      <div style={{  marginTop: '5px', fontSize: '14px', color: '#555' }}>
                      {maxLength - content.length} characters remaining </div>
                      {errors.content && <div className="invalid-feedback">{errors.content}</div>}
                    </div>

             
                   
                  </div>
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
           
              
                  <div className="form-group frm" style={{textAlign: 'left'}}>
                    <FormField
                           type="text"
                           isRequierd = {false}
                           id="amount"
                           name="adjusted_amount"
                           label="Order Code"
                          
                           value = {ticketDetails.order_code}
                           disabled={true}
                         
                        />
                     
                    </div>
               
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                     
                  
                     <label > Upload Payment Proof</label>
                     <br></br>
                     <input style={{width: '250px', display: 'inline'}} onChange={handleFileChange} type="file" className="form-control" id="imageInput"   name="f_name" />
                     
                  
                 </div>
                    
                
                  </div>
                </div>
                <br />
                <div align="left">
                  <button type="button" name="previous_btn_personal_details" id="previous_btn_personal_details" className="btn backbt" onClick={() => back('per_details')}>Back</button>
                  <button type="button" name="btn_personal_details" style={{'marginTop':'5px', marginLeft:'10px'}} id="btn_personal_details" className="btn ddfg "onClick={() => ReplyToTicket()}>Submit</button>
                  {userRole == 'ADMIN' && (
                    <button type="button" name="btn_personal_details" style={{'marginTop':'5px', marginLeft:'10px',backgroundColor:'red', fontSize:'13px', color:'white'}} id="btn_personal_details" className="btn  "onClick={() => closeTicket()}>Close</button>
                  )}
                  
                </div>
                <br />
              </div>
            </div>
          </div>
         
        
        </div>
      </form>
    </div>
  </div>
  </div>
  );


  }
 
   

export default withAuth(ReplyTicket);
